<template>
  <Popup v-bind="$attrs" v-on="$listeners">
    <div class="authenPopupBox">
      <div class="authenPopupText">您还未实名认证，请先完成认证</div>
    </div>
  </Popup>
</template>
<script>
import Popup from './Popup.vue';

export default {
  name: 'authenticationPopup',
  data() {
    return {};
  },
  components: {
    Popup,
  },
  methods: {
    clickImgCode() {
      this.$emit('sendPicCode');
    },
  },
};
</script>
<style scoped>
.authenPopupBox {
  text-align: left;
}
.authenPopupTip {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #001f33;
  margin-bottom: 12px;
}
.authenPopupText {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  color: #001F33;
  letter-spacing: 0;
}
</style>
